import { PairSource } from "../types/PairSource";

export const pairSources: { [key in PairSource]: string } = {
  [PairSource.QUICKSWAP]: "QuickSwap",
  [PairSource.UNISWAPV2]: "Uniswap v2",
  [PairSource.SUSHISWAP]: "SushiSwap",
};
